'use client';

import React, { useLayoutEffect, useRef } from 'react';
import { MainHeader } from './main-header/main-header';
import { SecondaryHeader } from './secondary-header/secondary-header';

type HeaderProps = {
  onHeaderHeightChange: (height: number) => void;
};

export const Header = ({ onHeaderHeightChange }: HeaderProps): React.JSX.Element => {
  const headerRef = useRef<HTMLElement>(null);

  useLayoutEffect(() => {
    const updateHeight = (): void => {
      if (headerRef.current) {
        const height = headerRef.current.offsetHeight;
        onHeaderHeightChange?.(height);
      }
    };

    window.addEventListener('resize', updateHeight);

    const observer = new ResizeObserver(updateHeight);
    if (headerRef.current) observer.observe(headerRef.current);

    updateHeight();

    return (): void => {
      window.removeEventListener('resize', updateHeight);
      observer.disconnect();
    };
  }, [onHeaderHeightChange]);

  return (
    <header ref={headerRef}
      className="shadow-sm bg-(--surface) sticky top-[0] z-100"
    >
      <SecondaryHeader />
      <MainHeader />
    </header>
  );
};
